import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-level-structure',
  templateUrl: './top-level-structure.component.html',
  styleUrls: ['./top-level-structure.component.scss']
})
export class TopLevelStructureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
